import React from 'react'
import {
  TextField,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  Typography,
} from '@mui/material'
import Grid from '@mui/material/Grid'
import { NSIPSFormData } from '@/features/internal/types/nsips'
import { NSIPS_CONSTANTS, NSIPS_LABELS, NSIPS_ERRORS } from '@/constants/nsips'

interface PatientInfoSectionProps {
  formData: NSIPSFormData
  errors: Record<string, string>
  onChange: (
    field: keyof NSIPSFormData
  ) => (event: React.ChangeEvent<HTMLInputElement>) => void
}

export const PatientInfoSection: React.FC<PatientInfoSectionProps> = React.memo(
  ({ formData, errors, onChange }) => {
    return (
      <Grid container spacing={3}>
        <Grid size={{ xs: 12, sm: 6 }}>
          <TextField
            fullWidth
            label={NSIPS_LABELS.PATIENT_CODE}
            value={formData.patientCode}
            onChange={onChange('patientCode')}
            required
            error={!!errors.patientCode}
            helperText={errors.patientCode}
          />
        </Grid>

        <Grid size={{ xs: 12, sm: 6 }}>
          <TextField
            fullWidth
            label={NSIPS_LABELS.PATIENT_KANA_NAME}
            value={formData.patientKanaName}
            onChange={onChange('patientKanaName')}
            required
            error={!!errors.patientKanaName}
            helperText={
              errors.patientKanaName || NSIPS_ERRORS.PATIENT_KANA_NAME_FORMAT
            }
          />
        </Grid>

        <Grid size={{ xs: 12, sm: 6 }}>
          <TextField
            fullWidth
            label={NSIPS_LABELS.PATIENT_KANJI_NAME}
            value={formData.patientKanjiName}
            onChange={onChange('patientKanjiName')}
            required
            error={!!errors.patientKanjiName}
            helperText={errors.patientKanjiName}
          />
        </Grid>

        <Grid size={{ xs: 12, sm: 6 }}>
          <FormControl error={!!errors.gender} required>
            <FormLabel>{NSIPS_LABELS.GENDER}</FormLabel>
            <RadioGroup
              row
              value={formData.gender}
              onChange={onChange('gender')}
            >
              <FormControlLabel
                value={NSIPS_CONSTANTS.GENDER.MALE}
                control={<Radio />}
                label={`男性(${NSIPS_CONSTANTS.GENDER.MALE})`}
              />
              <FormControlLabel
                value={NSIPS_CONSTANTS.GENDER.FEMALE}
                control={<Radio />}
                label={`女性(${NSIPS_CONSTANTS.GENDER.FEMALE})`}
              />
            </RadioGroup>
            {errors.gender && (
              <Typography variant="caption" color="error">
                {errors.gender}
              </Typography>
            )}
          </FormControl>
        </Grid>

        <Grid size={{ xs: 12, sm: 6 }}>
          <TextField
            fullWidth
            label={NSIPS_LABELS.BIRTH_DATE}
            value={formData.birthDate}
            onChange={onChange('birthDate')}
            required
            error={!!errors.birthDate}
            helperText={errors.birthDate || NSIPS_CONSTANTS.DATE_FORMAT}
            placeholder="20000101"
          />
        </Grid>
      </Grid>
    )
  }
)

PatientInfoSection.displayName = 'PatientInfoSection'
